import { render } from "./MailingBlockArticle.vue?vue&type=template&id=3238210f"
import script from "./MailingBlockArticle.vue?vue&type=script&lang=js"
export * from "./MailingBlockArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__